/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { InfoCircle1 } from '../../icons/InfoCircle1';
import './style.css';

export const Icon = ({
    property1,
    className,
    icon = <InfoCircle1 className="info-circle-2" />,
}) => {
    return (
        <div className={`icon ${className}`}>
            <div className="info-circle-wrapper">{icon}</div>
        </div>
    );
};

Icon.propTypes = {
    property1: PropTypes.oneOf(['default']),
};
